var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicateHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_151_152",
    "data-name": "Component 151 \\u2013 152",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.402,
    height: 29.254,
    viewBox: "0 0 23.402 29.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ffb109;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M127.666,12.145h5.485a.367.367,0,0,0,.366-.366,1.7,1.7,0,0,0-.609-1.3l-4.7-3.913a2.279,2.279,0,0,0-1.255-.451.45.45,0,0,0-.451.451v4.418A1.167,1.167,0,0,0,127.666,12.145Z",
    transform: "translate(-110.114 -6.112)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "M64.654,10.956V6.08H56.67a1.956,1.956,0,0,0-1.95,1.95V28.507a1.956,1.956,0,0,0,1.95,1.95H71.3a1.956,1.956,0,0,0,1.95-1.95V13.7H67.4A2.747,2.747,0,0,1,64.654,10.956Z",
    transform: "translate(-49.843 -6.08)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M27.489,50.633V30.4H26.27a1.956,1.956,0,0,0-1.95,1.95V53.8a1.956,1.956,0,0,0,1.95,1.95h15.6a1.956,1.956,0,0,0,1.95-1.95V52.584H29.439A1.956,1.956,0,0,1,27.489,50.633Z",
    transform: "translate(-24.32 -26.499)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateHover);
export default __webpack_public_path__ + "static/media/duplicate_hover.0f63187758b9e46875a1d3e19c7341a1.svg";
export { ForwardRef as ReactComponent };